export const ButtonSx = {
  border: '1px solid rgba(19, 20, 20, 0.5)',
  borderRadius: '30px',
  height: '36px',
  fontWeight: '600',
  fontSize: '14px',
  pl: '10px',
  pr: '10px',
};
